export default __webpack_public_path__ + "static/media/blockIcon.ab030bd5.svg";